export default function getMarginTopSm(value) {
  switch (value) {
    case -44:
      return "sm:-mt-44";
    case -40:
      return "sm:-mt-40";
    case -36:
      return "sm:-mt-36";
    case -32:
      return "sm:-mt-32";
    case -28:
      return "sm:-mt-28";
    case -24:
      return "sm:-mt-24";
    case -20:
      return "sm:-mt-20";
    case -16:
      return "sm:-mt-16";
    case -12:
      return "sm:-mt-12";
    case -8:
      return "sm:-mt-8";
    case -4:
      return "sm:-mt-4";
    case 0:
      return "sm:mt-0";
    case 1:
      return "sm:mt-1";
    case 2:
      return "sm:mt-2";
    case 3:
      return "sm:mt-3";
    case 4:
      return "sm:mt-4";
    case 5:
      return "sm:mt-5";
    case 6:
      return "sm:mt-6";
    case 7:
      return "sm:mt-7";
    case 8:
      return "sm:mt-8";
    case 9:
      return "sm:mt-9";
    case 10:
      return "sm:mt-10";
    case 12:
      return "sm:mt-12";
    case 14:
      return "sm:mt-14";
    case 16:
      return "sm:mt-16";
    case 20:
      return "sm:mt-20";
    case 24:
      return "sm:mt-24";
    case 28:
      return "sm:mt-28";
    case 32:
      return "sm:mt-32";
    case 36:
      return "sm:mt-36";
    case 40:
      return "sm:mt-40";
    default:
      return "";
  }
}
